export default __webpack_public_path__ + "static/media/3112.0da21d49.jpg";